import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { ValidateTransportService } from "../../services/validate-transport.service";
import { MatStepper } from "@angular/material/stepper";
import { PrevisionService } from "../../services/prevision.service";
import QRCode from "qrcode";
import { SendMailService } from "../../services/send-mail.service";
import { SendmailComponent } from "../../dialogs/sendmail/sendmail.component";
import { MatDialog } from "@angular/material/dialog";
import * as moment from "moment";
import { ScreenKeyboardComponent } from "../../components/screen-keyboard/screen-keyboard.component";
import { SendSmsService } from "../../services/send-sms.service";
import { AppConfigService, NotificationService, WebSocketService } from "@master/core/dist/core";
import { Subscription } from "rxjs/internal/Subscription";
import { MasterNetService } from "../../services/samcanet.service";
import { ErrorHandlingService } from "../../services/handle-error.service";
import { createDocumentFormGroup, createFirstFormGroup, createFourthFormGroup, createConditionsFormGroup, createSlotsFormGroup, createNormasDestinyFormGroup } from "@app/forms/form-groups-generic";
import { ValidateOrderService } from "../../services/validate-order.service";
import { backendValidationService } from "../../services/backend-validation.service";
import { GenerateTransportService } from '../../services/generate-transport.service';
import { EvaluateConditionsService } from "../../services/evaluate-coditions.service";
import { LoggerService } from "../../services/logger.service";
import { MSG_ERRORS } from "../../utils/error-messages";
import { TranslateService } from "@ngx-translate/core";
import { PluginService } from "@app/services/plugin.service";
import { LanguageService } from "@app/services/language.service";
import { SlotsService } from "@app/services/slots.service";

@Component({
  selector: "app-transport-form",
  templateUrl: "./transport-form.component.html",
  styleUrls: ["./transport-form.component.scss"],
})
export class TransportFormComponent implements OnInit, AfterViewInit {
  @ViewChild("stepper") public myStepper: MatStepper;
  @ViewChild("formDiv") public formDiv: any;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  conditionsFormGroup: FormGroup;
  slotsFormGroup: FormGroup;
  normasDestinyFormGroup: FormGroup;
  fourthFormGroup: FormGroup;
  documentFormGroup: FormGroup;
  transportData: any;
  public lane = null;
  QRDate: string;
  qr: any;
  private config: any;
  private setTransportData = false;
  public scroll = false;
  private matriculas: any;
  public showKeyboard = true;
  public useSlots: boolean;
  private generateTransportFromOrderServiceSubscription: Subscription;
  private validateTransportServiceSubscription: Subscription;
  private createPrevisionServiceSubscription: Subscription;
  private masterNetServicePrevisionAcceptedSubscription: Subscription;
  private masterNetServiceUpdateDateSubscription: Subscription;
  private formSubmitAttempt: boolean;

  @ViewChild("screenKeyboardComponent")
  private screenKeyboardComponent: ScreenKeyboardComponent;

  public sendSMSButtonDisabled = false;
  public identifier: any;
  public tknumOrderValue: string = "";
  public minDate: Date;
  public currentDate: Date;
  public maxDate: Date;
  private masternetOptions: any;
  public paletUnitsArray: any[];
  public slotDataSource: any = [];
  public originCenter: string;
  public headerTitleTemplate: string;
  public showAlbaran: boolean;
  public showPesoAlbaran: boolean;
  public plantDestinyName: string;
  public goToNextStepfromWS: any;
  public goToNextStepfromDB: any;
  public showDestinyPlantStandars: boolean;
  public useCleanningExpirationDocument: any;
  public showConditions: boolean;
  public useSlotsConditions: any;
  public invertedSlotsResult: boolean;
  public useStarndarDestinyPlantConditions: any;
  public normasPDF: string;
  public normasDestinyPDF: string;
  public shouldGenerateTransportNumber: boolean;
  public validateOrder: any;
  public checkTransportNumberResult: any;
  public validateCheckTransportResponse: any;
  public shouldValidateMasterNet: any;
  public updatePrevisionMasterNetWithGeneratedQr: boolean;
  public showPaletsForm: any;
  public qrGeneratorNumberOfPalets: number;
  public showRejectValidationTypologyConditionForTransports: any;
  public showRejectValidationTypologyConditionForOrders: any;
  public useCleanningExpirationDocumentConditions: any;
  public translatedCertificateTypes: any;
  public certificateTypes: any;
  public timesNoCleanning: any;
  public washers: any;
  public CERTIFICATE_DEDICATION = 'Certificado de Dedicación';
  public CERTIFICATE_CLEANNING = 'Certificado de Limpieza';
  private setDefaultSlot: boolean;
  private queueAvailable: any;
  private previsionFoundFromDB: any;
  private dateToShowSlotsFromModelName: string;
  private restrictionSlotsHourFromConfig: boolean;
  private slotsHourFromModelName: string;
  public language: string;
  public pdfLenguage: string;
  public showDedicacionOptions: boolean;
  public showWashersOptions: boolean;
  public languagesDataSource: any;
  public filterLanguages: any;
  public MMATRestriction: any;
  public defaultLanguage: string;
  public normasConditionPdfSource: string;
  public normasPlantDestinyPdfSource: string;
  public showPdfConditions: boolean;
  public showPdfNormasDestiny: boolean;
  public cleanningValues: any;
  public maxWeightAllow: any;
  private savingCurrentTransport: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private location: Location,
    private validateTransportService: ValidateTransportService,
    private validateOrderService: ValidateOrderService,
    private previsionService: PrevisionService,
    private wsService: WebSocketService,
    private sendMailService: SendMailService,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    private sendSmsService: SendSmsService,
    private slotsService: SlotsService,
    private appConfig: AppConfigService,
    private masterNetService: MasterNetService,
    private errorHandlingService: ErrorHandlingService,
    private backendValidationService: backendValidationService,
    private generateTransportService: GenerateTransportService,
    private evaluateConditionsService: EvaluateConditionsService,
    private loggerService: LoggerService,
    private translateService: TranslateService,
    private previsionPluginService: PluginService,
    private languageService: LanguageService
  ) {
    this.config = this.appConfig.getConfig().qrGeneratorConfig;
    this.initConfig();
    this.initLanguage();
    this.route.queryParams.subscribe((params) => {
      // tslint:disable-next-line:no-string-literal
      this.lane = params["lane"];
      // tslint:disable-next-line:no-string-literal
      // this.bussinesCode = '999999';
    });
    this.identifier = 0;
    this.showDedicacionOptions = false;
    this.showWashersOptions = false;
    this.defaultLanguage = 'es';
    this.showPdfConditions = true
    this.showPdfNormasDestiny = false
    this.translatedCertificateTypes = { dedication: '', cleaning: ''};
    this.savingCurrentTransport = false;
  }

  ngOnInit() {
    this.firstFormGroup = createFirstFormGroup(this.formBuilder, this.identifier); // Formulario
    this.documentFormGroup = createDocumentFormGroup(this.formBuilder); // Documentos limpieza cisterna
    this.conditionsFormGroup = createConditionsFormGroup(this.formBuilder);// condiciones
    this.slotsFormGroup = createSlotsFormGroup(this.formBuilder);// slots
    this.normasDestinyFormGroup = createNormasDestinyFormGroup(this.formBuilder);
    this.fourthFormGroup = createFourthFormGroup(this.formBuilder); // Could not be used

    this.translateService.use(this.defaultLanguage).subscribe(()=>{
      this.translateService.get('CERTIFICATE_TYPES').subscribe((types: string[]) => {
        this.certificateTypes = types
        console.log(this.certificateTypes);
        this.translatedCertificateTypes = {
          dedication: types[0],
          cleaning: types[1]
        };
      });
    });

    this.documentFormGroup.get('certificateType')?.valueChanges.subscribe((value) => {
      this.toggleCertificateFields(value);
    });
  }

  ngAfterViewInit() {
    this.myStepper.selectedIndex = 0; // It is unnecessary
  }

  ngOnDestroy(): void {
    this.createPrevisionServiceSubscription.unsubscribe();
    this.generateTransportFromOrderServiceSubscription.unsubscribe();
    this.validateTransportServiceSubscription.unsubscribe();
    this.masterNetServicePrevisionAcceptedSubscription.unsubscribe();
  }

  private initConfig(){
    try {
      if (this.config.cleanningExpirationDocumentConditions === undefined) {
        throw new Error("useCleanningExpirationDocument is undefined");
      } else if (this.config.slotsConditions === undefined) {
        throw new Error("useSlots is undefined");
      } else if (this.config.standarDestinyPlantsCondition === undefined) {
        throw new Error("useStandarDestinyPlants is undefined");
      } else if (this.config.showConditions === undefined) {
        throw new Error("showConditions is undefined");
      } else if (this.config.normasPDF === undefined) {
        throw new Error("normasPDF is undefined");
      } else if (this.config.normasDestinyPDF === undefined) {
        throw new Error("normasDestinyPDF is undefined");
      } else if (this.config.generateTransportNumber === undefined) {
        throw new Error("shouldGenerateTransportNumber is undefined");
      } else if (this.config.checkTransport === undefined) {
        throw new Error("checkTransport is undefined");
      } else if(this.config.validateCheckTransportResponse === undefined) {
        throw new Error("validateCheckTransportResponse is undefined");
      } else if (this.config.checkTransport.albaran === undefined) {
        throw new Error("checkTransport.albaran is undefined");
      } else if (this.config.checkTransport.pesoAlbaran === undefined) {
        throw new Error("checkTransport.pesoAlbaran is undefined");
      } else if (this.config.validateOrder === undefined) {
        throw new Error("validateOrder is undefined");
      } else if (this.config.checkTransportNumberResult === undefined) {
        throw new Error("checkTransportNumberResult is undefined");
      } else if (this.config.checkTransportNumberResult.validateMasterNet === undefined) {
        throw new Error("checkTransportNumberResult.validateMasterNet is undefined");
      } else if (this.config.checkTransportNumberResult.masternetOptions === undefined) {
        throw new Error("checkTransportNumberResult.masternetOptions is undefined");
      } else if (this.config.plantDestinyName === undefined) {
        throw new Error("plantDestinyName is undefined");
      } else if (this.config.updatePrevisionMasterNetWithGeneratedQr === undefined) {
        throw new Error("updatePrevisionMasterNetWithGeneratedQr is undefined");
      } else if (this.config.originCenter === undefined) {
        throw new Error("originCenter is undefined");
      } else if (this.config.showPaletsForm.active === undefined) {
        throw new Error("showPaletsForm.active is undefined");
      } else if (this.config.showPaletsForm.qrGeneratorNumberOfPalets === undefined) {
        throw new Error("showPaletsForm.qrGeneratorNumberOfPalets is undefined");
      } else if (this.config.setDefaultSlot === undefined){
        throw new Error("setDefaultSlot is undefined");
      } else if(this.config.headerTitleTemplate === undefined){
        throw new Error("headerTitleTemplate is undefined")
      } else if(this.config.shouldMoveToSecondStep == undefined) {
        throw new Error("shouldMoveToSecondStep is undefined")
      } else if(this.config.shouldMoveToSecondStep.goToNextStepfromWS == undefined) {
        throw new Error("goToNextStepfromWS is undefined")
      } else if(this.config.shouldMoveToSecondStep.goToNextStepfromDB == undefined) {
        throw new Error("goToNextStepfromBD is undefined")
      } else if(this.config.slotsConditions.dateToShowSlotsFromModelName == undefined) {
        throw new Error("slotsConditions.dateToShowSlotsFromModelName is undefined")
      } else if(this.config.slotsConditions.slotsHourFromModelName == undefined) {
        throw new Error("slotsConditions.slotsHourFromModelName is undefined")
      } else if(this.config.slotsConditions.restrictionSlotsHourFromConfig == undefined) {
        throw new Error("slotsConditions.restrictionSlotsHourFromConfig is undefined")
      } else if(this.config.shouldRejectValidationTypologyConditionForOrders == undefined) {
        throw new Error("shouldRejectValidationTypologyConditionForOrders is undefined")
      } else if(this.config.shouldRejectValidationTypologyConditionForTransports == undefined) {
        throw new Error("shouldRejectValidationTypologyConditionForTransports is undefined")
      } else if(this.config.cleanningExpirationDocumentCertified == undefined) {
        throw new Error("cleanningExpirationDocumentCertified is undefined")
      } else if(this.config.filterLanguages == undefined) {
        throw new Error("filterLanguages is undefined")
      } else if(this.config.shouldMoveToSecondStep.MMATRestriction == undefined) {
        throw new Error("MMATRestriction is undefined")
      } else {
        console.log("Todos los parámetros están definidos");
      }
      console.log('Config success:  ', this.config)
      this.loggerService.log('Configuration loaded successfully');
      this.originCenter = this.config.originCenter;
      this.headerTitleTemplate = this.config.headerTitleTemplate;
      this.showPaletsForm = this.config.showPaletsForm.active;
      this.qrGeneratorNumberOfPalets = this.config.showPaletsForm.qrGeneratorNumberOfPalets;
      this.goToNextStepfromWS = this.config.shouldMoveToSecondStep.goToNextStepfromWS;
      this.goToNextStepfromDB = this.config.shouldMoveToSecondStep.goToNextStepfromDB;
      this.showRejectValidationTypologyConditionForTransports = this.config.shouldRejectValidationTypologyConditionForTransports;
      this.showRejectValidationTypologyConditionForOrders = this.config.shouldRejectValidationTypologyConditionForOrders;
      this.useCleanningExpirationDocumentConditions = this.config.cleanningExpirationDocumentConditions;
      this.useSlotsConditions = this.config.slotsConditions;
      this.useStarndarDestinyPlantConditions = this.config.standarDestinyPlantsCondition;
      this.showConditions = this.config.showConditions; // Se muestran siempre
      this.normasPDF = this.config.normasPDF; // poner la que toca segun proyecto
      this.normasDestinyPDF = this.config.normasDestinyPDF; // poner la que toca segun proyecto
      this.shouldGenerateTransportNumber = this.config.generateTransportNumber; // Genera un nuevo transporte en SAP si el identificador comienza en 45
      this.showAlbaran = this.config.checkTransport.albaran; // muestra albaran en formulario
      this.showPesoAlbaran = this.config.checkTransport.pesoAlbaran; // muestra peso albaran en formulario
      this.validateOrder = this.config.validateOrder;
      this.checkTransportNumberResult = this.config.checkTransportNumberResult;
      this.validateCheckTransportResponse = this.config.validateCheckTransportResponse;
      this.shouldValidateMasterNet = this.config.checkTransportNumberResult.validateMasterNet;  // Hacer validacion contra masternet
      this.masternetOptions = this.config.checkTransportNumberResult.masternetOptions;  // Opciones de conexion masternet
      this.plantDestinyName = this.config.plantDestinyName; // Nombre de la planta destino
      this.updatePrevisionMasterNetWithGeneratedQr = this.config.updatePrevisionMasterNetWithGeneratedQr; // myta is true, Update
      this.setDefaultSlot = this.config.setDefaultSlot //set slot date and time if upcreating
      this.dateToShowSlotsFromModelName = this.config.slotsConditions.dateToShowSlotsFromModelName;
      this.slotsHourFromModelName = this.config.slotsConditions.slotsHourFromModelName;
      this.restrictionSlotsHourFromConfig = this.config.slotsConditions.restrictionSlotsHourFromConfig;
      //this.certificateTypes = this.config.cleanningExpirationDocumentCertified.certificateTypes;
      this.timesNoCleanning = this.config.cleanningExpirationDocumentCertified.timesNoCleanning;
      this.cleanningValues = this.timesNoCleanning[0];
      this.timesNoCleanning = this.timesNoCleanning.slice(1);
      this.washers = this.config.cleanningExpirationDocumentCertified.washers;
      this.filterLanguages = this.config.filterLanguages;
      this.MMATRestriction = this.config.shouldMoveToSecondStep.MMATRestriction;
    } catch(e) {
      console.log(`Error getting parameters ${e}`);
      this.loggerService.error('Error loading configuration');
    }
  }

  /**
   * Init languages options, by default is SPANISH
   */
  private async initLanguage(){
    this.languagesDataSource = await this.languageService.getLanguages();
    this.languagesDataSource = this.languagesDataSource.filter(language => this.filterLanguages.includes(language.isoCode));
    this.language = this.defaultLanguage;
    this.pdfLenguage = this.defaultLanguage;
    this.normasConditionPdfSource = `${this.normasPDF}_${this.pdfLenguage}.pdf`;
    this.normasPlantDestinyPdfSource =  `${this.normasDestinyPDF}_${this.pdfLenguage}.pdf`;
    this.translateService.getTranslation(this.language);
  }

/*   get selectedIndex() {
    return this.myStepper ? this.myStepper.selectedIndex : -1;
  } */
  get f1() {
    return this.firstFormGroup.controls;
  }
  get fConditionsForm() {
    return this.conditionsFormGroup.controls;
  }
  get fNormasDestinyFrom() {
    return this.normasDestinyFormGroup.controls;
  }

  setNormasConditionPdfSource(){
    console.log('NORMAS: ', this.normasPDF+'_'+this.pdfLenguage+'.pdf')
    this.normasConditionPdfSource =  this.normasPDF+'_'+this.pdfLenguage+'.pdf';
  }

  setNormasPlantDestinyPdfSource(){ // rever las normas para todos desde config o backend
    console.log('NORMAS DESTINO: ', this.normasDestinyPDF+'_'+this.pdfLenguage+'.pdf')
    this.normasPlantDestinyPdfSource =  this.normasDestinyPDF+'_'+this.pdfLenguage+'.pdf';
  }


// Habilitar el campo correspondiente según el valor de 'certificateType'
toggleCertificateFields(certificateType: string) {
  const dedicationControl = this.documentFormGroup.get('certificateDedication');
  const cleanningControl = this.documentFormGroup.get('certificateCleanning');

  if (certificateType === this.CERTIFICATE_DEDICATION) {
    dedicationControl?.setValidators([Validators.required]);
    dedicationControl?.updateValueAndValidity();
    cleanningControl?.clearValidators();
    cleanningControl?.updateValueAndValidity();
  } else if (certificateType === this.CERTIFICATE_CLEANNING) {
    cleanningControl?.setValidators([Validators.required]);
    cleanningControl?.updateValueAndValidity();
    dedicationControl?.clearValidators();
    dedicationControl?.updateValueAndValidity();
  }
}

// Método para verificar si el paso 1 es válido
isStepCleanningValid(): boolean {
  return this.documentFormGroup.valid;
}

  /**
   * Update fields form, when Order Number starts with 45
   */
  updateValidators(){
    console.log(`shouldGenrateTransportNumber`, this.shouldGenerateTransportNumber);
    console.log('Condition: ', ((this.shouldGenerateTransportNumber && this.showAlbaran && this.isOrder(this.firstFormGroup.controls['nTransporte'].value)) || !(this.isOrder(this.firstFormGroup.controls['nTransporte'].value))));
    if (this.isOrder(this.tknumOrderValue)){
      // Check config in order to Show Albaran field
      if(this.showAlbaran) {
        this.firstFormGroup.get('albaran').setValidators([Validators.required]);
        this.firstFormGroup.get('albaran').updateValueAndValidity();
      }
      // Check config in order to Show Peso Albaran field
      if(this.showPesoAlbaran) {
        this.firstFormGroup.get('pesoAlbaran').setValidators([Validators.required,Validators.minLength(5),Validators.maxLength(5),Validators.pattern('^[0-9]*$')]);
        this.firstFormGroup.get('pesoAlbaran').updateValueAndValidity();
      }
      if ((this.shouldGenerateTransportNumber && this.showAlbaran && this.isOrder(this.firstFormGroup.controls['nTransporte'].value)) || !(this.isOrder(this.firstFormGroup.controls['nTransporte'].value))){
        this.firstFormGroup.get('nTransportista').setValidators([Validators.required,Validators.pattern('^[0-9]*$')]);
        this.firstFormGroup.get('nTransportista').updateValueAndValidity();
      }
    }
    else{
      this.firstFormGroup.get('albaran').clearValidators();
      this.firstFormGroup.get('albaran').updateValueAndValidity();
      this.firstFormGroup.get('pesoAlbaran').clearValidators();
      this.firstFormGroup.get('pesoAlbaran').updateValueAndValidity();
    }
  }

  /**
   * Cleanning options
   */
  updateCertificates(): void {
    const tipoCertificado = this.documentFormGroup.get('certificateType')?.value;

    this.showDedicacionOptions = tipoCertificado === this.translatedCertificateTypes.dedication; //'Certificado de Dedicación';
    this.showWashersOptions = tipoCertificado === this.translatedCertificateTypes.cleaning;//'Certificado de Limpieza';

    if (!this.showDedicacionOptions)
      this.documentFormGroup.get('certificateDedication')?.setValue(''); // Reinicia el valor de dedicación si no se muestra

    if (!this.showWashersOptions)
      this.documentFormGroup.get('certificateCleanning')?.setValue(''); // Reinicia el valor de dedicación si no se muestra

  }

  /**
   *
   *  VALIDACION DE TRANSPORTE
   *
   */

  goToValidateTransport() {
    this.loggerService.log(`Processing step: ${this.myStepper.selectedIndex}`);
    if (this.screenKeyboardComponent) {
      // TODO: We must assign the right form here.
      this.screenKeyboardComponent.form = this.secondFormGroup; // activate keyboard
    }
    this.matriculas = this.f1.frontPlate.value + " " + this.f1.rearPlate.value;
    this.identifier = this.firstFormGroup.controls["nTransporte"].value;

    // Caso ONDA
    //TODO: test here PHASE 2
    if(this.shouldGenerateTransportNumber && this.isOrder(this.identifier)) {
      this.loggerService.log(`Calling generateTransportNumber()`);
      this.generateTransportNumber();
    }
    this.getShippingInfo();
  }
  /**
   * PHASE 2
   */
  generateTransportNumber() {
    this.generateTransportFromOrderServiceSubscription = this.generateTransportService.generateTransportNumber(
      this.f1.nTransporte.value, this.f1.nTransportista.value
    ).subscribe(
      (data)=>{
        console.log("result generateTransportFromOrderNumber " + JSON.stringify(data));
        this.loggerService.log(`result generateTransportFromOrderNumber: ${JSON.stringify(data)}`);
        this.handleGenerateTransportNumberResponse(data);
      },
      (err) => {
         /* // Check error vars are not the same
        if (err.error.error && err.error.error === "ORDER not available") {
          this.firstFormGroup.controls["nTransporte"]
          // tslint:disable-next-line:object-literal-key-quotes
          .setErrors({
            serverError: "No se dispone de información sobre este pedido",
          });
        } */
        this.handleErrors(err)
      }
    );
  }

  /**
   *  Get shipping information
   * @param packet Data who come after generate trasnport number | data.EBELN = this.f1.nTransporte.value;
   * @returns
   */
  getShippingInfo(packet?) {

    if (packet){ // It happens when transport is created before |  && generateTransportNumber is true
      let nTransporte = 0;
      nTransporte = packet.TKNUM;
      this.f1.nTransporte.setValue(packet.TKNUM)
      this.setTransportData = true;
    }

    //Should validate order ?
    if (this.isOrder(this.identifier)) {
      if(this.config.validateOrder.validate){
        //FASE 2 - caso MYTA: se pasara centro y nº transporte TKNUM para validar el pedido (45XXXXX)
        //const center = this.config.validateOrder.center; // NOW center is nots needed
            this.validateOrderService.validateOrder(this.f1, this.matriculas, null).subscribe(
              (data) => {
                console.log(data);
                this.handleCheckTransportNumberResponse(data);
              },
              (error) => {
                this.handleErrors(error)
                //this.notificationService.showError(error.message);
              }
            );
            return;
      } else {
        this.notificationService.showError("La validación de pedidos no está activada")
        return;
      }
    }
    else {
        const configTransport = this.config.checkTransport;
        this.validateTransportService.validateTransport(this.f1, this.matriculas, configTransport, packet).subscribe(
          (data) => {
            console.log('validate check transport: ', data)
            this.loggerService.log(`validate check transport: ${JSON.stringify(data)}`);
            this.handleCheckTransportNumberResponse(data); // ok
          },
          (error) => {
            this.handleErrors(error)
            //this.notificationService.showError(error.message);
          }
        );
      }
  }

 /**
 * Handle only response of order validation. Useb by MYTA for now
 * @param data
 */
  handleOrderValidation(data: any) {
    //TODO: FASE 2 - Check this
    if (data.root && data.root.Envelope.Body.Fault.Reason.Text.$data) {
      this.firstFormGroup.controls["nTransporte"].setErrors({
        serverError: this.getTranslatedError('msg_order_not_found'),
      });
    } else if (data.PO_RESULT == "NOK") {
      this.firstFormGroup.controls["nTransporte"].setErrors({
        serverError: data.PO_ERROR,
      });
    } else {
      this.transportData = data;
      this.transportData.frontPlate = this.f1.frontPlate.value;
      this.transportData.rearPlate = this.f1.rearPlate.value;
      this.transportData.STCD1 = this.transportData.STCD1 ? this.transportData.STCD1 : "--";
      this.myStepper.next();
    }
  }

  /**
   * Validate order in masterNET and assign slots
   * @param data
   */
  validateMasterNet():boolean {
    //TODO: FASE2 - Need test
    // It is only ejecuted if originCenter is MYTA
    // Try to delegate to backend this function inside backendValidationService

    let resultValidation;
    this.masterNetServicePrevisionAcceptedSubscription = this.validateTransportService.validateMasterNet(this.f1.nTransporte.value, this.f1.nTransportista.value).subscribe((response) => {
      if (response.length == 0) {
        this.firstFormGroup.controls["nTransporte"].setErrors({ serverError: `El transporte ${this.f1.nTransporte.value} no ha sido aceptado en Masternet` });
        resultValidation = false
      } else {
        resultValidation = true
      }
    });
    return resultValidation
  }

  async handleGenerateTransportNumberResponse(data) {
    //TODO: Mejorar esto a respuesta modularizada
      if (data.root && data.root.Envelope.Body.Fault.Reason.Text.$data) {
        // tslint:disable-next-line
        this.firstFormGroup.controls["nTransporte"].setErrors({
        serverError: this.getTranslatedError('msg_order_not_found'),
        });
    } else if(data.PO_RESULT == 'NOK') {
        // tslint:disable-next-line
        this.firstFormGroup.controls["nTransporte"].setErrors({
        serverError: data.PO_ERROR,
        });

    } else { // si ha salido bien, solicitar Get Shipping Info:

        data.EBELN = this.f1.nTransporte.value;
        this.getShippingInfo(data);
    }
  }

  // pasar a handlers.ts
  async handleCheckTransportNumberResponse(dataTransport) {

    //let condition = {"TPLST":{"ne":"MY01"}};   myta
    //let condition = {"TPLST":{"ne":"TI02"}};   agrotim
    //let condition = {"and":[{"TPLST":{"ne":"TI01"}},{"TPLST":{"ne":"NOV1"}},{"TPLST":{"ne":"NOV2"}}]};  novapet
    //let condition = {"and":[{"TPLST":{"ne":"SM07"}},{"TPLST":{"ne":"ECS7"}},{"TPLST":{"ne":"NOV2"}},{"TPLST":{"ne":"EC03"}},{"TPLST":{"ne":"AF52"}},{"TPLST":{"ne":"AF61"}},{"TPLST":{"ne":"ECA3"}}]} onda
    let respRejectOrder = null;
    let respOrderCompleted = null;
    let resp = null;
    console.log(`showRejectValidationTypologyConditionForOrders: `,this.showRejectValidationTypologyConditionForOrders);
    console.log(`showRejectValidationTypologyConditionForTransports`, this.showRejectValidationTypologyConditionForTransports);
    if (this.isOrder(this.identifier)){
      try {
        respRejectOrder = await this.evaluateConditionsService.evaluateConditions(dataTransport, this.showRejectValidationTypologyConditionForOrders.condition, this.showRejectValidationTypologyConditionForOrders.inverse);
        respOrderCompleted = await this.evaluateConditionsService.evaluateConditions(dataTransport, this.showRejectValidationTypologyConditionForOrders.conditionOrderCompleted, this.showRejectValidationTypologyConditionForOrders.inverseOrderCompleted);
        console.log(`Evaluate order condition: `, respRejectOrder);
        console.log(`Evaluate order condition completed: `,respOrderCompleted);
        this.loggerService.log(`Evaluate order condition: ${respRejectOrder}`);
        this.loggerService.log(`Evaluate order condition completed: ${respOrderCompleted}`);
      } catch (error) {
        this.handleErrors(error)
      }
    } else{
      try {
        resp = await this.evaluateConditionsService.evaluateConditions(dataTransport, this.showRejectValidationTypologyConditionForTransports.condition, this.showRejectValidationTypologyConditionForTransports.inverse);
        console.log(`Evaluate transporte condition: `,respRejectOrder);
        this.loggerService.log(`Evaluate transporte condition: ${resp}`);
      } catch (error) {
        this.handleErrors(error)
      }
    }

    if(respRejectOrder || respOrderCompleted || resp) {
      if(respRejectOrder) {
        const message = `El número de pedido no pertenece a ${this.config.originCenter}`;
        this.setTransportError(message, message);
        return;
      }

      if(respOrderCompleted) {
        const message = `Pedido no activo o completado `;
        this.setTransportError(message, message);
        return;
      }

      if(resp) {
        const message = `El número de transporte no pertenece a ${this.config.originCenter}`;
        this.setTransportError(message, message);
        return;
      }

    } else {

      // Save fields, update frontPlate, rearPlate from the form (f1)
      dataTransport = this.assignPlatesDataToTransport(dataTransport, this.f1)
      // Save field MMAT restriction
      dataTransport = this.assignMaxWeightAllow(dataTransport, this.f1)
      // Find Queue Type available
      this.queueAvailable = await this.getQueueType(dataTransport)
      this.loggerService.log(`Queue Type available: ${this.queueAvailable}`);
      //Assign queue to prevision
      dataTransport.queueType = this.queueAvailable;
      //TODO: fillTransportDataByPlugin
      dataTransport = await this.fillTrasportDataPlugin(dataTransport)
      console.log('from map prevision : ', dataTransport);
    }

    // if prevision is accepted ot not | case MYTA FASE 2
    if(this.config.checkTransportNumberResult.validateMasterNet && !this.isOrder(this.identifier)) {
      if(!this.validateMasterNet()) {
        return;
      }
    }

    // Evaluate condition cleaning
    if(this.useCleanningExpirationDocumentConditions.condition != false)
      try {
        this.useCleanningExpirationDocument = await this.evaluateConditionsService.evaluateConditions(dataTransport, this.useCleanningExpirationDocumentConditions.condition, this.useCleanningExpirationDocumentConditions.inverse);
      } catch (error) {
        this.handleErrors(error)
      }
    else this.useCleanningExpirationDocument = false
    this.loggerService.log(`Evaluate condition cleaning: ${this.useCleanningExpirationDocument}`);
    //Evaluate slots condition
    /**
     * !"SHTYP: [ZT00] !TPLST: [TI01] !RESLO: [] !LGORT: [MP01]""
      !"SHTYP: [ZM00] TPLST: [NOV2] RESLO: [TI01] LGORT: [GR01]"
      !"SHTYP: [ZM00] TPLST: [NOV1] RESLO: [GR01] LGORT: [TI01]"
    */
    console.log('Slots condition: ', this.useSlotsConditions.condition);
    if(this.useSlotsConditions.condition != false)
      try {
        this.useSlots = await this.evaluateConditionsService.evaluateConditions(dataTransport, this.useSlotsConditions.condition, this.useSlotsConditions.inverse)
        this.loggerService.log(`Evaluate slots condition: ${this.useSlotsConditions.condition}`);
      } catch (error) {
        this.handleErrors(error)
      }
    else this.useSlots = false
    this.loggerService.log(`Evaluate slots: ${this.useSlots}`);

    //Evaluate standar destiny plant condition
    if(this.useStarndarDestinyPlantConditions.condition != false)
      this.showDestinyPlantStandars = await this.evaluateConditionsService.evaluateConditions(dataTransport, this.useStarndarDestinyPlantConditions.condition, this.useStarndarDestinyPlantConditions.inverse)
    else this.showDestinyPlantStandars = false
    this.loggerService.log(`Evaluate standars destiny plant condition: ${this.showDestinyPlantStandars}`);

    if(this.useSlots) {
      // should palets form
      if(this.showPaletsForm) {
        this.loggerService.log(`Show palets form: ${this.showPaletsForm}`);
        this.assignPalets();
      }

      try {
        let {minDate, maxDate} = await this.slotsService.getMaxMinDateForSlots(dataTransport);
        if (minDate && maxDate){
          this.minDate = minDate;
          this.maxDate = maxDate;
        } else {
          this.loggerService.error(`Error getting values for minDate: ${minDate} or maxDate: ${maxDate}`);
        }
      } catch(error) {
        console.log('Error: ', error);
        this.loggerService.error(JSON.stringify(error));
      }
    }
    //Test logs
    console.log('slots :', this.useSlots);
    console.log('queue available :',this.queueAvailable);
    console.log('cisternas :',this.useCleanningExpirationDocument);
    console.log('planta destino :',this.showDestinyPlantStandars);

    this.transportData = dataTransport
    this.shouldMoveNextStep(dataTransport);
  }

  private assignDedicationToTransport() {
    if(this.showDedicacionOptions) {
      console.log(`certificado dedicación: `,this.documentFormGroup.get('certificateDedication').value);
      this.transportData.ZZDEDICACION = this.documentFormGroup.get('certificateDedication').value
    } /* else {
      this.transportData.ZZDEDICACION = this.cleanningValues.id
    } */
    console.log('DEDICACION: ', this.transportData.ZZDEDICACION)
  }

  private assignWasherToTransport() {
    if(this.showWashersOptions) {
      console.log(`Asignacion de lavadero: `,this.documentFormGroup.get('certificateCleanning').value);
      this.transportData.ZLAVADERO = this.documentFormGroup.get('certificateCleanning').value
    }
    console.log('LAVADERO: ',this.transportData.ZLAVADERO)
  }

  /**
   * Assign front and rear plate to Prevision
   */
  private assignPlatesDataToTransport(dataTransport, f1) {
    dataTransport.frontPlate = f1.frontPlate.value;
    dataTransport.rearPlate = f1.rearPlate.value;
    return dataTransport
  }

  private assignMaxWeightAllow(dataTransport, f1) {
    dataTransport.maxWeightAllow = f1.maxWeightAllow.value;
    const maxWeightAllow = this.f1.maxWeightAllow.value;
    dataTransport.ZZAPTOPESOMAX = maxWeightAllow; // feature 44.000Kg
    return dataTransport
  }
  

  /**
   * * TODO: esta es la llamada que se ha de desviar a un plugin
   * recibirá la previsión por parámetro y la devolverá modificada
   * @param dataTransport
   * @returns dataTransport
   */
  private async fillTrasportDataPlugin(dataTransport: any){
    try {
      const transportResponse = await this.previsionPluginService.map(dataTransport);
      return transportResponse;
    } catch (error) {
      this.loggerService.error(error)
    }
  }

  /**
   *
   * @param dataTransport
   * @returns
   */

  private async getQueueType(dataTransport){
    try {
      const result = await this.backendValidationService.getCapacities(dataTransport);
      console.log('Getting queueType from Capacities: ',result);
      return result
    } catch (error) {
      console.log('Get capacities Error: ', error);
    }
  }

  private assignPalets() {
    this.paletUnitsArray = [
      { desc: `Hasta ${this.qrGeneratorNumberOfPalets} palets`, value: 0 }, //cambiar valor cuando vienen con menos de n palets.
      { desc: `Más de ${this.qrGeneratorNumberOfPalets} palets`, value: 1 },
    ];
  }

  private setTransportError(message: string, messageTranslated: string) {
    this.firstFormGroup.controls["nTransporte"].setErrors({
      serverError: messageTranslated,
    });
    this.loggerService.log(`Transport error: ${message}`);
  }

  private setMMATError(message: string, messageTranslated: string) {
    this.firstFormGroup.controls["maxWeightAllow"].setErrors({
      serverError: messageTranslated,
    });
    this.loggerService.log(`MMAT error: ${message}`);
  }

  private async shouldMoveNextStep(data:any){
    // check if should move next setp
    let allowNextStep = null;
    let allowNextStepFromDB;
    //Allow move next step depends on condition
    let allowNextStepFromWS = await this.evaluateConditionsService.evaluateConditions(data, this.goToNextStepfromWS.condition, this.goToNextStepfromWS.inverse);
    // Find prevision
    try {
      this.previsionFoundFromDB = await this.previsionService.findPrevisionByTKNUM(data.TKNUM);
    } catch(error) {
      console.log('Prevision Found in DB ERROR: ', error);
      this.setTransportError(MSG_ERRORS.msg_error_getting_prevision, this.getTranslatedError('msg_error_getting_prevision'));
    }

    if (Object.keys(this.previsionFoundFromDB).length > 0) {
      this.previsionFoundFromDB = this.previsionFoundFromDB[0];
      // asosciar al formalario del slot la fecha de slotDate y la hora??
      
      if(moment.utc(this.previsionFoundFromDB.slotDateTime).isAfter(moment.utc()) && !this.isOrder(this.identifier)){
        this.getSlots(this.previsionFoundFromDB.slotDate)
      }
      
      allowNextStepFromDB =  await this.evaluateConditionsService.evaluateConditions(this.previsionFoundFromDB, this.goToNextStepfromDB.condition, this.goToNextStepfromDB.inverse);
    }
    else {this.previsionFoundFromDB = null;
      allowNextStepFromDB = false
    };
    console.log(`allowNextStepFromWS: `, allowNextStepFromWS);
    console.log(`allowNextStepFromDB: `, allowNextStepFromDB);
    let MMATRestriction = false;
    if (this.MMATRestriction.condition != false){
         MMATRestriction = await this.evaluateConditionsService.evaluateConditions(data, this.MMATRestriction.condition, this.MMATRestriction.inverse); 
        if(MMATRestriction) {
          console.log('[ MMAT Restriction ]: Es necesaria homologación para MMA de 44T');
          this.setMMATError(MSG_ERRORS.msg_error_mmat_restriction, this.getTranslatedError('msg_error_mmat_restriction'));
        }
    }
   
    if(MMATRestriction) {
      console.log('[ MMAT Restriction ]: Es necesaria homologación para MMA de 44T');
      this.setMMATError(MSG_ERRORS.msg_error_mmat_restriction, this.getTranslatedError('msg_error_mmat_restriction'));
    }

    // MMAT Restriction tiene que ser false para que avance, las demas basta que con una sea TRUE
    allowNextStep = ((allowNextStepFromWS || allowNextStepFromDB) && !MMATRestriction)

    if(allowNextStep) {
      this.myStepper.next();
      console.log(`stepper index: `,this.myStepper.selectedIndex);
    }
    else {
      if (!MMATRestriction) this.setTransportError(MSG_ERRORS.msg_wrong_status_transport, this.getTranslatedError('msg_wrong_status_transport'));
    }
  }


  public goToExpiracionClieanningDocument() {
    this.myStepper.next();
    console.log(`stepper index cisternas`, this.myStepper.selectedIndex);
  }


  /**
   * Set vars and condition, also send to save prevision if everything was OK
   * @param stepNumber
   */
   async goToSaveTransport() {
    
    /*if(this.savingCurrentTransport){
      this.notificationService.showErrorTimer('Saving transport');
      return;
    }
    this.savingCurrentTransport = true;
    */
    // check vaidation
    let state = (!this.showDestinyPlantStandars && this.conditionsFormGroup.get("conditionsCtrl").value !== "") || (this.showDestinyPlantStandars && this.conditionsFormGroup.get("conditionsCtrl").value !== "" && this.normasDestinyFormGroup.get("normasDestinyCtrl").value !== "");
    if (state) {      
      //TODO:  PLUGIN ????
      if (this.useSlots) {
        this.transportData.slot = this.slotsFormGroup.get("slot").value;
        this.transportData.slotDate = moment(this.slotsFormGroup.get("slotDate").value).format("YYYY-MM-DD");

        this.slotDataSource.forEach((slot) => {
          if (slot.ids === this.slotsFormGroup.get("slot").value) {
            this.transportData.slotTime = slot.time;
          }
        });
        this.transportData.slotDateTime = moment(this.slotsFormGroup.get("slotDate").value).format("YYYY-MM-DD") + " " + this.transportData.slotTime;
      }

      console.log(JSON.stringify(this.transportData));
      // Crear la previsión, si no ha sido guardada en el slot
      console.log('Prevision saved in step : ', this.myStepper.selectedIndex);
      // Set chosen language to prevision
      this.transportData.language = this.language
      // Este es el final debe estar todo aceptado para que llegue aqui
      this.createPrevisionServiceSubscription = this.previsionService.createPrevision(this.transportData).subscribe(
        (value) => {
          this.handleCreatePrevisionSuccess(value);
          this.savingCurrentTransport = false;    
        },
        (err) => {
          this.savingCurrentTransport = false;
          // Aquí deberías recibir el error completo que el microservicio envió
          console.log('Error response from Microservice:', err.error.error);
          // err.error.message -> el mensaje personalizado;
          // err.error.error -> el objeto con el error completo;
          this.handleErrors(err)
        }
      );
    } else {

      this.myStepper.next();
      console.log('moving to step: ', this.myStepper.selectedIndex);
    }
  }


  /*********************** */
  /* ERROR HANDLER SECTION
  /*********************** */
  /**
   * Error generic handler
   * @param err
   */
  handleErrors(err: any) {
    this.errorHandlingService.handleGenericErrors(
        err,
        () => this.handleTransportistaError(),
        () => this.handlePrimaryUniqueError(),  // Lógica de "PRIMARY must be unique"
        () => this.handleSlotNotAvailableError(),  // Lógica de "SLOT not available"
        () => this.handleOrderNumberError(),  // Lógica de "ORDER NUMBER QR already generated for today"
        () => this.handleOrderNotAvailable(), // Lógica de "Order not avaliable"
        () => this.onGenericError()  // Lógica de "ORDER NUMBER QR already generated for today"
    );
  }

  private handleTransportistaError(){
    this.firstFormGroup.controls["nTransporte"].setErrors({
      serverError: this.getTranslatedError('msg_error_transportista')
    });
    this.myStepper.selectedIndex = 0;
  }

  /**
   * Handle primary unique Error
   */
  private handlePrimaryUniqueError() {
    this.firstFormGroup.controls["nTransporte"].setErrors({
      serverError: this.getTranslatedError('msg_prevision_already_exists'),
    });
    this.myStepper.selectedIndex = 0;
  }
  /**
   * Handle slots errors | FASE 2
   */
  private handleSlotNotAvailableError() {
    if(this.useSlots) this.resetValuesSlotsFormGroup();
    this.slotsFormGroup.controls["slotDate"].setErrors({
      serverError: this.getTranslatedError('msg_slot_not_available')
    });
    setTimeout(() => {
      if(this.useCleanningExpirationDocument){
        this.myStepper.selectedIndex = 2;
      }else{
        this.myStepper.selectedIndex = 1;
      }
    }, 1500);

  }

  private handleOrderNumberError() {

    this.firstFormGroup.controls["nTransporte"]
    // tslint:disable-next-line:object-literal-key-quotes
    .setErrors({
      serverError: this.getTranslatedError('msg_qr_already_generated'),
    });
    //if(this.useSlots) this.resetValuesSlotsFormGroup();
    setTimeout(() => {
      this.myStepper.selectedIndex = 0;
    }, 1500);

  }
  private handleOrderNotAvailable() {
    this.firstFormGroup.controls["nTransporte"]
    // tslint:disable-next-line:object-literal-key-quotes
    .setErrors({
      serverError:  this.getTranslatedError('msg_order_not_available'),
    });
  }
  private onGenericError() {
    this.firstFormGroup.controls["nTransporte"].setErrors({
      serverError:  this.getTranslatedError('msg_generic_error'),
    });
    this.myStepper.selectedIndex = 0;
  }



  /*********************** */
  /* END ERROR HANDLER SECTION
  /*********************** */


  /**
   * Handler when prevision was created successfully
   * @param value
   */
  handleCreatePrevisionSuccess(value: any) {
    if (this.lane) {
      this.sendQRToWebSocket(value.QR)
      window.close();
    } else {
      this.handleQRCodeGeneration(value);
    }
  }

  handleQRCodeGeneration(value: any) {
    const opts = {
      errorCorrectionLevel: "H",
      type: "image/jpeg",
      quality: 0.3,
      margin: 1,
      color: {
        dark: "#010599FF",
        light: "#FFBF60FF",
      },
    };

    this.qr = value.QR;
    this.QRDate = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    console.log(this.QRDate);
    console.log(value.QR);
    if(value.QR) {
      QRCode.toDataURL(value.QR, opts, (err, url) => {
        if (err) {
          console.log('Error : ', err);
         // throw (err(document.getElementById("qr-image") as HTMLImageElement).src =  url);
        } else {
            // Check if it needs to send prevision updated to MASTERNET
            if (this.config.updatePrevisionMasterNetWithGeneratedQr) {
              //TODO: TEST HERE
              if(!this.isOrder(this.transportData.TKNUM)) {
                this.transportData.qrGenerated = 1;
                this.masterNetServiceUpdateDateSubscription = this.masterNetService.updatePrevisionDate(this.transportData).subscribe(() => {
                  console.log("Fecha actualizada");
                  this.masterNetServiceUpdateDateSubscription.unsubscribe();
                });
            }
            this.myStepper.selectedIndex = this.myStepper.steps.length - 1;
          } else  {
            this.myStepper.next();
          }
        }
      });
    } else {
      // In case error, check create or update previsions
      this.notificationService.showError("Datos insuficientes para generar QR")
    }

  }

  // Reset first form
  public resetValuesFirtsFormGroup() {
    this.firstFormGroup.get("nTransportista").setValue(null);
    this.firstFormGroup.get("nTransporte").setValue(null);
    this.firstFormGroup.get("dniConductor").setValue(null);
    this.firstFormGroup.get("nombreConductor").setValue(null);
    this.firstFormGroup.get("movilConductor").setValue(null);
    this.firstFormGroup.get("frontPlate").setValue(null);
    this.firstFormGroup.get("rearPlate").setValue(null);
  }
  public resetValuesSlotsFormGroup() {
    this.slotsFormGroup.get("slotDate").setValue(null);
    this.slotsFormGroup.get("slot").setValue(null);
  }

  private sendQRToWebSocket(qr: string) {
     const payload = {
        msg_type: "QR",
        lane: Number(this.lane),
        data: {
          QR: qr,
          printFlag: true,
        },
      };
      this.transportData = null;
      this.wsService.send("newQR", payload);
  }


  isFieldInvalid(field: string) {
    return (
      (!this.firstFormGroup.get(field).valid &&
        this.firstFormGroup.get(field).touched) ||
      (this.firstFormGroup.get(field).untouched && this.formSubmitAttempt)
    );
  }

  goBack() {
    this.location.back();
  }

  //TODO: Check this
  sendMail() {
    const dialogRef = this.dialog.open(SendmailComponent, {
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((email) => {
      // tslint:disable-next-line:object-literal-shorthand
      const params = {
        qr: this.qr,
        email: email,
        TKNUM: this.transportData.TKNUM,
        VBELN: this.transportData.VBELN,
        date: this.QRDate,
        //NAME1: this.transportData.NAME1, MYTA MADERUELO SLOTS FIELDS
        //ARKTX: this.transportData.ARKTX,
        //slot: this.transportData.slotDateTime ? `${moment(this.transportData.slotDateTime).format("DD-MM-yyyy HH:mm:ss")} ` : undefined,
      };
      if (params.email && params.qr) {
        this.sendMailService.sendMail(params).subscribe(() => {});
      }
    });
  }

  //TODO: Check this
  sendSMS() {
    // tslint:disable-next-line:max-line-length
    let smsInterval = null;
    this.sendSMSButtonDisabled = true;
    const params = {
      qr: this.qr,
      telefono: this.transportData.ZZMOVIL,
      NAME1: this.transportData.NAME1,
      ARKTX: this.transportData.ARKTX,
      TKNUM: this.transportData.TKNUM,
      VBELN: this.transportData.VBELN,
      LDDAT: this.transportData.LDDAT,
      slot: this.transportData.slotDateTime,
    };
    if (params.telefono && params.qr) {
      this.sendSmsService.sendSMS(params).subscribe(
        (result) => {
          if (result.statusCode === 1000) {
            this.notificationService.showSuccess(
              "Mensaje SMS enviado correctamente"
            );
            this.sendSMSButtonDisabled = true;
            clearInterval(smsInterval);
          } else {
            this.notificationService.showError(
              result.statusCode + " " + result.statusText
            );
            clearInterval(smsInterval);
            this.sendSMSButtonDisabled = false;
          }
        },
        (error) => {
          this.notificationService.showError(error);
          clearInterval(smsInterval);
          this.sendSMSButtonDisabled = false;
        }
      );
    }
    if (this.sendSMSButtonDisabled){
      smsInterval =setInterval(()=>{this.sendSMSButtonDisabled = false}, 30000);
    }
  }

  resetVars() {
    window.location.href = "https://expediciones.samca.com/";
  }

  onStepChange(event: any) {
    if (!event.selectedIndex) {
      this.showKeyboard = true;
    } else {
      this.showKeyboard = false;
    }
  }

  setFirstForm(): void {
    this.screenKeyboardComponent.form = this.firstFormGroup;
  }

  setSecondForm(): void {
    this.screenKeyboardComponent.form = this.secondFormGroup;
  }

  closeWindow() {
    window.close();
  }

  keyboardClass() {
    if (this.lane != null && this.showKeyboard) {
      return "keyboard";
    }
  }

  scrollUp() {
    this.scroll = !this.scroll;
    this.formDiv.nativeElement.scrollTop = 0;
    // this.myScrollVariable = 0;
  }

  scrollDown() {
    this.scroll = !this.scroll;
    console.log(this.formDiv.nativeElement);
    this.formDiv.nativeElement.scrollTop = this.formDiv.nativeElement.scrollHeight;
  }


  public async getSlots(value) {

    this.slotDataSource = [];
    //TODO: probar a generar fechas aquí:
    //Modification 02/02/2024 If the prevision exists and the reserved slot is
    if (this.setDefaultSlot && !this.isOrder(this.identifier) && this.previsionFoundFromDB != null && moment.utc(this.previsionFoundFromDB.slotDateTime).isAfter(moment.utc())) {

      if (this.previsionFoundFromDB != null && Object.keys(this.previsionFoundFromDB).length > 0) {
        this.previsionFoundFromDB = Array.isArray(this.previsionFoundFromDB)
            ? this.previsionFoundFromDB[0]
            : this.previsionFoundFromDB;
      }
      else this.previsionFoundFromDB = null;
      this.loggerService.log(`getSlots findPrevisionByTKNUM : ${this.previsionFoundFromDB}`);

      if (this.previsionFoundFromDB != null) 
      {
        value = this.previsionFoundFromDB.slotDate;
        console.log('from prevision value: ', value);
        this.slotsFormGroup.get("slotDate").setValue(value);
      }
    }

    var isNotCurrentDate = moment(value).isAfter(moment(new Date()), "day");

    //TODO: mostrar un modal que avise de están escogiendo una fecha distinta de la propuesta!
    let nSlots: number = 1;
    if (this.transportData?.VSART != null && this.transportData?.VSART == "10") nSlots = 2;

    //NOVAPET- it comes from capacity table resolving
    const type = this.queueAvailable;
    this.loggerService.log(`Queue type avalilable : ${type}`);

    this.slotsService
      .list(value, type , nSlots)
      .subscribe((data) => {
        const now = new Date();
        //remove 15 minutes from actual time to allow user can select current slot the first half hour
        if (now.getMinutes() >= 15 /*30*/) now.setMinutes(now.getMinutes() - 15 /*30*/);
        else {
          now.setHours(now.getHours() - 1);
          now.setMinutes(now.getMinutes() + 45 /*30*/);
        }
        console.log("current now time: " + now);

        if (  
            this.setDefaultSlot && this.previsionFoundFromDB != null 
            && !this.isOrder(this.identifier) 
            && moment.utc(this.previsionFoundFromDB.slotDateTime).isAfter(moment.utc())
        )
        { //esto hace que solo tenga en cuenta fechas posteriores al momento actual
          console.log('Setting slot default');
          this.setDefaultSlot = false;
          let defaultSlot= {
                ids: this.previsionFoundFromDB.slot, //"/23281/23282/"
                time: moment(this.previsionFoundFromDB.slotDateTime).format('HH:mm:ss') ,//"11:00:00"
                date: this.previsionFoundFromDB.slotDate,//"2024-02-07"
          }

          this.slotDataSource.push(defaultSlot)
          this.slotsFormGroup.get('slot').setValue(defaultSlot.ids);
          this.slotsFormGroup.get('slotDate').setValue(new Date(value))
        }
        //TODO: PASAR
         data.forEach((element) => {
          if (!isNotCurrentDate) {
            let aux1 = moment(element.time, "HH:mm:ss");
            let aux2 = moment(moment(now).format("HH:mm:ss"), "HH:mm:ss");
            let result = aux1 >= aux2;
            if (result){
              console.log('pushing ...', element);
              //TODO:mirar si el campo que hemos puesto en la configuración tiene valor distinto de 11:00
              //y si es así comparar el elemento con el valor de this.transportData[parámetro que llega de la config]
              this.slotDataSource.push(element);
            }

          } else {
            console.log('Pushing no current date: ', element);
            // Define las horas
            let difenceTim = moment(this.transportData[this.slotsHourFromModelName], "HH:mm").isAfter(moment(element.time,"HH;mm"))
            console.log(difenceTim);
            if (this.restrictionSlotsHourFromConfig && difenceTim) return;
            this.slotDataSource.push(element);
          }
        });
        
        this.slotDataSource = Array.from(new Map(this.slotDataSource.map(obj => [obj.ids, obj])).values());
        console.log('slotDataSource removing duplicated keys: ', this.slotDataSource);
        if (this.slotDataSource.length == 0) {
          this.slotsFormGroup.controls["slotDate"].setErrors({
            serverError: this.getTranslatedError('msg_slot_not_available'),
          });
          this.loggerService.log(`getSlots: ${MSG_ERRORS.msg_slot_not_available}`);
        }

      },
      (error) => {
        this.slotsFormGroup.controls["slotDate"].setErrors({
          serverError: this.getTranslatedError('msg_slots_error'),
        });
        this.loggerService.log(`getSlots error : ${JSON.stringify(error)}`);
      });

  }

  // Función para avanzar al siguiente paso visible
  public goToNextStep(step: number) {

    if(step === 0) {
      this.goToValidateTransport();
      return;
    }
    if(step >= 2 && step < 6) {
      //slots
      console.log(this.useSlots)
      if(this.useSlots) {
        if(step  == 2) {
          this.goToSaveTransport();
          return;
        }
      } else {
        this.myStepper.next();
        console.log('step slots skiped, moving next step: ', this.myStepper.selectedIndex);
      }
      // condiciones ALWAYS active
      if(step == 3){
        if(this.showDestinyPlantStandars) {
          this.showPdfConditions = false
          this.showPdfNormasDestiny = true
          console.log(this.normasPlantDestinyPdfSource);
        }
        console.log('show PDF Normas');
        this.goToSaveTransport();
        return;
      }
      // normas planta destino
      if(step == 4 && this.showDestinyPlantStandars) {
        this.goToSaveTransport();
        return;
      }
    } else {
      //Cisternas
      if(step === 1 && this.useCleanningExpirationDocument) {
        this.assignDedicationToTransport();
        this.assignWasherToTransport()
        this.goToExpiracionClieanningDocument();
        return;
      } else {
        this.myStepper.next();
        console.log('step cisternas skiped, move next step: ', this.myStepper.selectedIndex);
      }
    }
  }

  goToPreviousStep(step = null) {
  /*
    0 form
    1 cisterna
    2 slot
    3 condic
    4 normas
  */
    // voy hacia las normas
    // esoty en cisternas o en slots
    if(step && ( step == 2 || step == 3)) {
      console.log('cambiando a condiciones ', step);
      this.showPdfNormasDestiny = false
      this.showPdfConditions = true
    }
    this.myStepper.previous();
    console.log(this.myStepper.selectedIndex);
  }

  /**
   * Check if TKNUM is a transport or an order
   * @returns boolean
   */
  private isOrder(identifier): boolean {
    return identifier.startsWith('45')
  }


  /* TRANSLATES AND LANGUAGES  */

  public getTranslatedError(keyerror) {
    const translatedError = this.translateService.instant(keyerror);
    // Si no se encuentra la traducción, cambiar a inglés como predeterminado
    if (this.language != this.defaultLanguage && !translatedError || translatedError === keyerror) { // Cuando no existe la clave traducida
      const defaultLanguageForeigner = 'en';
      return this.translateService.translations[defaultLanguageForeigner]?.[keyerror]
        || this.translateService.instant('msg_generic_error');
    }
    return translatedError;
  }

  public changeLanguage($event: any) {
    console.log('Selected language: ', $event);
    this.showWashersOptions = false;
    this.showDedicacionOptions = false;
    this.changeLocaleLanguage($event.value);
  }

  private changeLocaleLanguage(localeCode: string): void {
    this.language = localeCode;
    this.pdfLenguage = this.language
    console.log(`Current language: ${this.language}`);

    this.translateService.use(localeCode).subscribe(()=>{
      this.translateService.get('CERTIFICATE_TYPES').subscribe((types: string[]) => {
        this.certificateTypes = types;
        console.log(this.certificateTypes);
        this.translatedCertificateTypes = {
          dedication: types[0],
          cleaning: types[1]
        };
      });
    });

    this.setNormasConditionPdfSource()
    this.setNormasPlantDestinyPdfSource()
    this.backendValidationService.checkIfPdfExists(this.normasConditionPdfSource).subscribe((exists) => {
      if (!exists) {
        console.log(`El PDF de condiciones : ${localeCode} no existe.`);
        if(localeCode != this.defaultLanguage) {
          this.pdfLenguage = 'en';
          this.setNormasConditionPdfSource()
        }
      }
    });

    if(this.useStarndarDestinyPlantConditions) {
      this.backendValidationService.checkIfPdfExists(this.normasPlantDestinyPdfSource).subscribe((exists) => {
        if (!exists) {
          console.log(`El PDF de Normas: ${localeCode} de destino no existe.`);
          if(localeCode != this.defaultLanguage)
          this.pdfLenguage = 'en';
          this.setNormasPlantDestinyPdfSource();
        }
      });
    }
  }

}
